'use strict';


const COUNTRIES = require('./generated/countries');
const parse = require('./parse/parse');


module.exports = {
  COUNTRIES,
  parse
};



// WEBPACK FOOTER //
// ./src/index.js